import { TAG } from "../constants";
import {
  PaymentInformation,
  SetDefaultPaymentMethodBody,
  SetDefaultPaymentMethodReturn,
} from "../types";
import { patientApi } from "./patientApi";

export const paymentMethodsApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentMethods: builder.query<PaymentInformation[], void>({
      query: () => ({
        method: "GET",
        url: "/api/patient/payments-information",
      }),
      providesTags: [TAG.PAYMENT_METHODS],
    }),
    setDefaultPaymentMethod: builder.mutation<
      SetDefaultPaymentMethodReturn,
      SetDefaultPaymentMethodBody
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/patient/payment-methods/default",
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          paymentMethodsApi.util.updateQueryData(
            "getPaymentMethods",
            undefined,
            (draft) => {
              draft.forEach((method, index, methods) => {
                if (method.is_default === true) {
                  methods[index] = {
                    ...method,
                    is_default: false,
                  };
                }
                if (method.external_id === args.paymentMethodId) {
                  methods[index] = {
                    ...method,
                    is_default: true,
                  };
                }
              });
            },
          ),
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
    removePaymentMethod: builder.mutation<void, string>({
      query: (id) => ({
        method: "DELETE",
        url: `/api/patient/payment-methods/${id}`,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          paymentMethodsApi.util.updateQueryData(
            "getPaymentMethods",
            undefined,
            (draft) => {
              const index = draft.findIndex(
                (method) => method.external_id === args,
              );
              if (index >= 0) {
                draft.splice(index, 1);
              }
            },
          ),
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
  }),
});

export const {
  useRemovePaymentMethodMutation,
  useGetPaymentMethodsQuery,
  useSetDefaultPaymentMethodMutation,
} = paymentMethodsApi;
